export default "__VITE_ASSET__BuPgAS8n__"